import React from 'react';
import {CartItemOptionsDataHook} from './ItemDetails';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {DetailLine} from './DetailLine';
import {classes} from './ItemDetails.st.css';
import {useTranslation} from '@wix/yoshi-flow-editor';

export const DetailsGroup = ({
  itemId,
  group,
}: {
  itemId: string;
  group: {descriptionLines: string[]; groupName?: string};
}) => {
  const {t} = useTranslation();

  return (
    <>
      {group.groupName && (
        <Text data-hook={CartItemOptionsDataHook.GroupName} className={classes.groupName}>
          {t('cart.lineItems.modifiers.categoryLabel', {categoryName: group.groupName})}
        </Text>
      )}
      <ul className={classes.options} data-hook={CartItemOptionsDataHook.GroupOptionsList}>
        {group.descriptionLines?.map((descriptionLine) => (
          <li key={`${itemId}-${descriptionLine}`}>
            <DetailLine value={descriptionLine} />
          </li>
        ))}
      </ul>
    </>
  );
};
